import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { ApiClient } from '../api-client';
import { AgencyLocation } from './agency-location';

@Injectable()
export class AgencyLocationService extends ApiClient {
  store: Subject<AgencyLocation[]>;
  path = '/agencies_locations';

  constructor(protected http: Http) {
    super(http);
    this.store = <Subject<AgencyLocation[]>>new Subject();
  }

  //use v1/agencies_locations endpoint to get the agency_location detail
  getAgencyLocation(id:string): Observable<any> {
    const url = `${this.baseUrl}/v1/agencies_locations/${id}`;

    return this.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/api/resources/agency-location.service.ts